// extracted by mini-css-extract-plugin
module.exports = {"Page":"ManagerDiscoveryProvinces_Page__3c6FM","NameGroup":"ManagerDiscoveryProvinces_NameGroup__1iwcT","CategoryList":"ManagerDiscoveryProvinces_CategoryList__2K1cc"};